module.exports = __webpack_public_path__ + "img/douban.159f4360.png";